
import { configureStore } from '@reduxjs/toolkit'
import mainReducer from '@store/slice/mainSlice'
import missionReducer from '@store/slice/missionSlice'
import mediaManagerReducer from '@store/slice/mediaManagerSlice'
import missionSeasonReducer from '@store/slice/missionSeasonSlice'
import loginReducer from '@store/slice/loginSlice'
import sterilizationReducer from '@store/slice/sterilizationSlice'
import documentsReducer from '@store/slice/documentsSlice'
import usersReducer from '@store/slice/usersSlice'
import districtsReducer from '@store/slice/districtsSlice'
import missionBillingReducer from '@store/slice/missionBillingSlice'
import dashboardReducer from '@store/slice/dashboardSlice'
import cmsReducer from '@store/slice/cmsSlice'
import mailTemplatesReducer from '@store/slice/mailTemplatesSlice'
import permissionsReducer from '@store/slice/permissionsSlice'
import pilotReducer from '@store/slice/pilotSlice'

export const store = configureStore({
  reducer: {
    main: mainReducer,
    mission: missionReducer,
    mediaManager: mediaManagerReducer,
    missionSeason: missionSeasonReducer,
    missionBillings: missionBillingReducer,
    login: loginReducer,
    sterilization: sterilizationReducer,
    users: usersReducer,
    documents: documentsReducer,
    districts: districtsReducer,
    dashboard: dashboardReducer,
    cms: cmsReducer,
    mailTemplates: mailTemplatesReducer,
    pilot: pilotReducer,
    permissions: permissionsReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false,
  })
})
